import { render, staticRenderFns } from "./complex.vue?vue&type=template&id=bf493f5e&scoped=true"
import script from "./complex.vue?vue&type=script&lang=js"
export * from "./complex.vue?vue&type=script&lang=js"
import style0 from "./complex.vue?vue&type=style&index=0&id=bf493f5e&prod&lang=scss&scoped=true"
import style1 from "./complex.vue?vue&type=style&index=1&id=bf493f5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf493f5e",
  null
  
)

export default component.exports